export default __webpack_public_path__ + "static/media/portfolio-143.c1072035.jpg";